export default function Footer() {
    return (
        <footer>
            Copyright © 2023 Trường Đại học Sài Gòn
        </footer>
    )
}